class PaneraVideoPlayer extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.btn = this.querySelector('.panera-video-player__btn');

    if (!this.video || !this.btn) return;

    this.btn.addEventListener('click', this.toggle.bind(this));
    this.video.addEventListener('pause', () => this.updateState(true));
    this.video.addEventListener('play', () => this.updateState(false));

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.video.pause();
    }

    this.updateState(this.video.paused);
  }

  toggle() {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  updateState(isPaused) {
    this.classList.toggle('panera-video-player--paused', isPaused);
    this.btn.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
  }
}

if (!customElements.get('panera-video-player')) {
  customElements.define('panera-video-player', PaneraVideoPlayer);
}
